import { useEffect } from 'react';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import { useUrlParams } from '#hooks/useUrlParams.ts';

const PARAM_SCHEMA = { tab: 'scalar' } as const;

/**
 * This hook consolidates routing logic for the host add/edit forms.
 */
export function useHostTabs() {
  const { state } = useAppLocation();
  const [params, setParams] = useUrlParams(PARAM_SCHEMA);

  const tab =
    params.tab === 'general' ? ('general' as const)
    : params.tab === 'advanced' ? ('advanced' as const)
    : ('unknown' as const);

  const tabLinkProps = {
    general: { queryParamTarget: 'general' },
    advanced: { queryParamTarget: 'advanced' },
  };

  const setTab = {
    general: () => setParams({ tab: 'general' }),
    advanced: () => setParams({ tab: 'advanced' }),
  };

  // Navigate to 'general' tab by default
  useEffect(() => {
    if (tab === 'unknown') {
      setParams(
        { tab: 'general' },
        {
          // Propagate the current state so `from` still works
          state,
          // Replace the "no tab selected" history with `general` in the history.
          replace: true,
        }
      );
    }
  }, [setParams, state, tab]);

  return { tab, tabLinkProps, setTab };
}
